"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetPersonalProductLists = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationUtils = require("@ori/presentation-utils");
/* istanbul ignore file */ const useGetPersonalProductLists = ()=>{
    const { customerId } = (0, _auth.useToken)();
    const { tenant } = (0, _environment.useEnvironment)();
    return (0, _globalApiClientReact.useGetCustomerProductListTypeProductLists)(customerId, 'Personal', {
        [_fetching.TENANT_CONTEXT]: tenant
    }, {
        swr: (0, _presentationUtils.getRetryErrorSwrOptions)()
    });
};
exports.useGetPersonalProductLists = useGetPersonalProductLists;
